import { render, staticRenderFns } from "./WeChatSettingsSection.vue?vue&type=template&id=14adc276&scoped=true&"
import script from "./WeChatSettingsSection.vue?vue&type=script&lang=js&"
export * from "./WeChatSettingsSection.vue?vue&type=script&lang=js&"
import style0 from "./WeChatSettingsSection.vue?vue&type=style&index=0&id=14adc276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14adc276",
  null
  
)

export default component.exports